import {
    AbstractControl,
    NG_VALIDATORS,
    ValidationErrors,
    Validator
} from '@angular/forms';
import { Directive, Input } from '@angular/core';

/**
 * Validate the min number of a `input[type=text]`.
 * Number fields cannot be used because we can’t force English decimal point on them.
 */
@Directive({
    selector: '[pkpMaxNumberValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: MaxNumberValidatorDirective,
            multi: true
        }
    ]
})
export class MaxNumberValidatorDirective implements Validator {
    @Input('pkpMaxNumberValidator') subject: number;

    validate(control: AbstractControl): ValidationErrors | null {
        try {
            return control.value <= this.subject
                ? null
                : { pkpMaxNumberValidator: { value: control.value } };
        } catch (e) {
            return null;
        }
    }
}
